import { acceptHMRUpdate, defineStore } from 'pinia';
import type {
  Grocery,
  GroceryChanges,
  GroceryInput,
} from '@/service/groceries/types';
import type { GroceryClientInterface } from '@/service/groceries/groceryClient';

export function useGroceryStore(client: GroceryClientInterface) {
  const store = defineStore('groceries', () => {
    // Live list shared with the family
    const groceries = client.collectionRef();

    return {
      groceries,
      add(item?: GroceryInput): Promise<Grocery> {
        return client.add(item);
      },
      update(id: string, changes: GroceryChanges): Promise<void> {
        return client.update(id, changes);
      },
      remove(id: string): Promise<void> {
        return client.remove(id);
      },
      clear(): Promise<void> {
        return client.removeAll(groceries.value.map(({ id }) => id));
      },
    };
  });

  if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
  }

  return store();
}
